import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ListadoIcon = props => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SvgIcon {...props} viewBox="0 0 27.815 33.589">
      <g
        id="_001-lista-de-verificacin"
        data-name="001-lista-de-verificacin"
        transform="translate(-44.001)"
      >
        <g
          id="Grupo_528"
          data-name="Grupo 528"
          transform="translate(57.253 9.972)"
        >
          <g id="Grupo_527" data-name="Grupo 527" transform="translate(0)">
            <path
              id="Trazado_167"
              data-name="Trazado 167"
              d="M256.1,152h-9.447a.656.656,0,0,0,0,1.312H256.1a.656.656,0,1,0,0-1.312Z"
              transform="translate(-246.001 -152)"
            />
          </g>
        </g>
        <g
          id="Grupo_530"
          data-name="Grupo 530"
          transform="translate(63.94 13.121)"
        >
          <g id="Grupo_529" data-name="Grupo 529">
            <path
              id="Trazado_168"
              data-name="Trazado 168"
              d="M349.061,200.193a.656.656,0,1,0,.192.464A.661.661,0,0,0,349.061,200.193Z"
              transform="translate(-347.941 -200.001)"
            />
          </g>
        </g>
        <g
          id="Grupo_532"
          data-name="Grupo 532"
          transform="translate(57.252 2.821)"
        >
          <g id="Grupo_531" data-name="Grupo 531" transform="translate(0)">
            <path
              id="Trazado_169"
              data-name="Trazado 169"
              d="M247.111,43.193a.656.656,0,1,0,.192.464A.661.661,0,0,0,247.111,43.193Z"
              transform="translate(-245.991 -43.001)"
            />
          </g>
        </g>
        <g
          id="Grupo_534"
          data-name="Grupo 534"
          transform="translate(57.253 13.12)"
        >
          <g id="Grupo_533" data-name="Grupo 533" transform="translate(0)">
            <path
              id="Trazado_170"
              data-name="Trazado 170"
              d="M250.585,200h-3.928a.656.656,0,0,0,0,1.312h3.928a.656.656,0,1,0,0-1.312Z"
              transform="translate(-246.001 -200)"
            />
          </g>
        </g>
        <g
          id="Grupo_536"
          data-name="Grupo 536"
          transform="translate(57.253 17.057)"
        >
          <g id="Grupo_535" data-name="Grupo 535" transform="translate(0)">
            <path
              id="Trazado_171"
              data-name="Trazado 171"
              d="M256.1,260h-9.447a.656.656,0,0,0,0,1.312H256.1a.656.656,0,1,0,0-1.312Z"
              transform="translate(-246.001 -260)"
            />
          </g>
        </g>
        <g
          id="Grupo_538"
          data-name="Grupo 538"
          transform="translate(63.94 20.206)"
        >
          <g id="Grupo_537" data-name="Grupo 537">
            <path
              id="Trazado_172"
              data-name="Trazado 172"
              d="M349.061,308.193a.656.656,0,1,0,.192.464A.661.661,0,0,0,349.061,308.193Z"
              transform="translate(-347.941 -308.001)"
            />
          </g>
        </g>
        <g
          id="Grupo_540"
          data-name="Grupo 540"
          transform="translate(57.253 20.206)"
        >
          <g id="Grupo_539" data-name="Grupo 539" transform="translate(0)">
            <path
              id="Trazado_173"
              data-name="Trazado 173"
              d="M250.585,308h-3.928a.656.656,0,1,0,0,1.312h3.928a.656.656,0,1,0,0-1.312Z"
              transform="translate(-246.001 -308)"
            />
          </g>
        </g>
        <g
          id="Grupo_542"
          data-name="Grupo 542"
          transform="translate(57.253 24.142)"
        >
          <g id="Grupo_541" data-name="Grupo 541" transform="translate(0)">
            <path
              id="Trazado_174"
              data-name="Trazado 174"
              d="M256.1,368h-9.447a.656.656,0,0,0,0,1.312H256.1a.656.656,0,1,0,0-1.312Z"
              transform="translate(-246.001 -368)"
            />
          </g>
        </g>
        <g
          id="Grupo_544"
          data-name="Grupo 544"
          transform="translate(63.94 27.291)"
        >
          <g id="Grupo_543" data-name="Grupo 543">
            <path
              id="Trazado_175"
              data-name="Trazado 175"
              d="M349.061,416.193a.656.656,0,1,0,.192.464A.661.661,0,0,0,349.061,416.193Z"
              transform="translate(-347.941 -416.001)"
            />
          </g>
        </g>
        <g
          id="Grupo_546"
          data-name="Grupo 546"
          transform="translate(57.253 27.291)"
        >
          <g id="Grupo_545" data-name="Grupo 545" transform="translate(0)">
            <path
              id="Trazado_176"
              data-name="Trazado 176"
              d="M250.585,416h-3.928a.656.656,0,1,0,0,1.312h3.928a.656.656,0,1,0,0-1.312Z"
              transform="translate(-246.001 -416)"
            />
          </g>
        </g>
        <g id="Grupo_548" data-name="Grupo 548" transform="translate(44.001)">
          <g id="Grupo_547" data-name="Grupo 547" transform="translate(0)">
            <path
              id="Trazado_177"
              data-name="Trazado 177"
              d="M68.618,2.559H63.607a4.019,4.019,0,0,0-2.781-1.115h-.575a2.624,2.624,0,0,0-4.687,0h-.576a4.019,4.019,0,0,0-2.78,1.115H47.2a3.2,3.2,0,0,0-3.2,3.2V30.39a3.2,3.2,0,0,0,3.2,3.2H68.618a3.2,3.2,0,0,0,3.2-3.2V5.757A3.2,3.2,0,0,0,68.618,2.559Zm-13.628.2h1.022a.656.656,0,0,0,.632-.481,1.312,1.312,0,0,1,2.529,0,.656.656,0,0,0,.632.481h1.021A2.726,2.726,0,0,1,63.54,5.248H52.276A2.726,2.726,0,0,1,54.989,2.755ZM70.5,30.39a1.889,1.889,0,0,1-1.887,1.887H47.2a1.889,1.889,0,0,1-1.887-1.887V5.757A1.889,1.889,0,0,1,47.2,3.871h4.09a4.011,4.011,0,0,0-.335,1.607V5.9a.656.656,0,0,0,.656.656H64.205a.656.656,0,0,0,.656-.656V5.478a4.011,4.011,0,0,0-.335-1.607h4.091A1.889,1.889,0,0,1,70.5,5.757Z"
              transform="translate(-44.001)"
            />
          </g>
        </g>
        <g
          id="Grupo_550"
          data-name="Grupo 550"
          transform="translate(48.02 9.622)"
        >
          <g id="Grupo_549" data-name="Grupo 549" transform="translate(0)">
            <path
              id="Trazado_178"
              data-name="Trazado 178"
              d="M110.978,146.859a.656.656,0,0,0-.928,0l-2.805,2.805-.864-.864a.656.656,0,1,0-.928.928l1.328,1.328a.656.656,0,0,0,.928,0l3.269-3.269A.656.656,0,0,0,110.978,146.859Z"
              transform="translate(-105.261 -146.667)"
            />
          </g>
        </g>
        <g
          id="Grupo_552"
          data-name="Grupo 552"
          transform="translate(48.331 24.142)"
        >
          <g id="Grupo_551" data-name="Grupo 551" transform="translate(0)">
            <path
              id="Trazado_179"
              data-name="Trazado 179"
              d="M113.806,368h-3.149a.656.656,0,0,0-.656.656V371.8a.656.656,0,0,0,.656.656h3.149a.656.656,0,0,0,.656-.656v-3.149A.656.656,0,0,0,113.806,368Zm-.656,3.149h-1.837v-1.837h1.837Z"
              transform="translate(-110.001 -368)"
            />
          </g>
        </g>
        <g
          id="Grupo_554"
          data-name="Grupo 554"
          transform="translate(48.331 17.057)"
        >
          <g id="Grupo_553" data-name="Grupo 553" transform="translate(0)">
            <path
              id="Trazado_180"
              data-name="Trazado 180"
              d="M113.806,260h-3.149a.656.656,0,0,0-.656.656V263.8a.656.656,0,0,0,.656.656h3.149a.656.656,0,0,0,.656-.656v-3.149A.656.656,0,0,0,113.806,260Zm-.656,3.149h-1.837v-1.837h1.837Z"
              transform="translate(-110.001 -260)"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default ListadoIcon;
